<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>结算中心</el-breadcrumb-item>
        <el-breadcrumb-item>账户资金</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow align-center">
      <p>可提现金额：</p>
      <p class="mgt10 withdraw-amount-text-style">￥{{ withdrawAmount }}</p>
      <div class="mgt10">
        <el-button type="primary" size="small" style="width: 150px" @click="linkToWithdrawPage"> 提 现 </el-button>
      </div>
      <el-button type="text" @click="linkToWithdrawDetailPage"> 提现明细 </el-button>
    </div>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span>结算列表：</span>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ tableData.length }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="时间" prop="settlementDate"> </el-table-column>

        <el-table-column :render-header="renderSettlementOrderNum" align="center" label="结算订单数" prop="settlementOrderNum"> </el-table-column>

        <el-table-column :render-header="renderPreSettlementAmount" align="center" label="预结算金额(元)" prop="preSettlementAmount"> </el-table-column>

        <el-table-column :render-header="renderPlatMaintainAmount" align="center" label="平台维护费(元)" prop="platMaintainAmount"> </el-table-column>

        <el-table-column :render-header="renderSettlementAmount" align="center" label="结算金额(元)" prop="settlementAmount"> </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      withdrawAmount: 0,
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/settlement/accountBalance",
        method: "GET",
        params: {
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.withdrawAmount = res.body.data.settlementAmount;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 结算订单数format
     * @param h
     * @param column
     * @param $index
     * @returns {boolean}
     */
    renderSettlementOrderNum(h, { column, $index }) {
      return (
        <span>
          结算订单数
          <el-tooltip class="item" effect="dark" content="结算订单数 = 当月实际完成订单数" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
      );
    },
    /**
     * 预结算金额format
     * @param h
     * @param column
     * @param $index
     * @returns {boolean}
     */
    renderPreSettlementAmount(h, { column, $index }) {
      return (
        <span>
          预结算金额
          <el-tooltip class="item" effect="dark" content="预结算金额 = 当月实际消费金额" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
      );
    },
    /**
     * 平台维护费format
     * @param h
     * @param column
     * @param $index
     * @returns {boolean}
     */
    renderPlatMaintainAmount(h, { column, $index }) {
      return (
        <span>
          平台维护费
          <el-tooltip class="item" effect="dark" content="平台维护费 = 平台运营维护费用，收取实际消费金额的5%" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
      );
    },
    /**
     * 结算金额format
     * @param h
     * @param column
     * @param $index
     * @returns {boolean}
     */
    renderSettlementAmount(h, { column, $index }) {
      return (
        <span>
          结算金额
          <el-tooltip class="item" effect="dark" content="结算金额 = 预结算减去相关服务费" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
      );
    },
    /**
     * 跳转至提现页面
     */
    linkToWithdrawPage() {
      this.$router.push({
        name: "withdraw",
        query: {
          withdrawAmount: this.withdrawAmount,
        },
      });
    },
    /**
     * 跳转至提现明细页面
     */
    linkToWithdrawDetailPage() {
      this.$router.push({
        name: "withdrawDetail",
      });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .hx-form-container {
    .withdraw-amount-text-style {
      font-size: 30px;
      font-weight: 600;
    }
  }
}
</style>
